import React, { useState } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../../styles/theme';
import PackageComparisonChart from '../PackageComparisonChart';

const Section = styled.section`
  margin-top: ${theme.spacing['2xl']};
`;

const ToggleButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border: 1px solid var(--login-form-border);
  border-radius: 16px;
  background: var(--login-form-bg);
  box-shadow: var(--login-form-shadow);
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(72, 138, 236, 0.35);
  }

  &:focus-visible {
    outline: 2px solid var(--login-primary);
    outline-offset: 2px;
  }
`;

const Title = styled.span`
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--login-form-text);
`;

const Hint = styled.span`
  font-size: ${theme.typography.fontSize.sm};
  font-weight: 500;
  color: var(--login-form-muted);
`;

const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Chevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: var(--login-form-input-bg);
  color: var(--login-primary);
  font-size: 1.25rem;
  line-height: 1;
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.$open ? '180deg' : '0deg')});
`;

const Panel = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.25s ease, margin-top 0.25s ease;
  max-height: ${(props) => (props.$open ? '5000px' : '0')};
  opacity: ${(props) => (props.$open ? 1 : 0)};
  margin-top: ${(props) => (props.$open ? theme.spacing.lg : '0')};
`;

export default function CollapsibleComparePackages({ selectedPackage, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Section>
      <ToggleButton
        type="button"
        aria-expanded={isOpen}
        aria-controls="account-setup-compare-packages"
        onClick={() => setIsOpen((open) => !open)}
      >
        <TitleGroup>
          <Title>Compare All Packages</Title>
          <Hint>{isOpen ? 'Hide feature comparison' : 'View full feature comparison'}</Hint>
        </TitleGroup>
        <Chevron $open={isOpen} aria-hidden>
          ▾
        </Chevron>
      </ToggleButton>

      <Panel id="account-setup-compare-packages" $open={isOpen} aria-hidden={!isOpen}>
        <PackageComparisonChart selectedPackage={selectedPackage} />
      </Panel>
    </Section>
  );
}
